import { useContext, useRef, useState, useEffect } from "react";
import Input from "../../../components/custom/forms/Input";
import { contextProvider } from "../../../../context/ContextProvider";
import InputSearchMini from "../../../components/custom/forms/InputSearchMini";
import apiPrivateAntesala from "../../../../config/ConfigPrivate";
import Alerts from "../../../components/Alerts/Alerts";
import RestPrivateAntesala from "../../../../helpers/RestPrivateApi";

const Donde = ({ setForm, form, setValidation, validation, tieneSiteMap, puedeAgregarSiteMap }) => {
  const context = useContext(contextProvider);
  const { FORMs, VALIDATIONs, URLs } = context;
  const controllerRef = useRef(null);

  const { VALIDATION_FORM_EVENTO, VALIDATION_FORM_EVENTO_SALA } = VALIDATIONs;
  const { FORM_EVENTO_SALA, FORM_EVENTO } = FORMs;
  const { URL_SALA_SEARCH } = URLs;

  const [salas, setSalas] = useState([]);
  const [sala, setSala] = useState(false);
  const [loadingSalas, setLoadingSalas] = useState(false);
  const [salaSeleccionada, setSalaSeleccionada] = useState(false);

  // Estados para mapas
  const [mapasDisponibles, setMapasDisponibles] = useState([]);
  const [loadingMapas, setLoadingMapas] = useState(false);
  const [mapaSeleccionado, setMapaSeleccionado] = useState(null);
  const [mostrarMapas, setMostrarMapas] = useState(false);

  const fetchSala = async (params, signal) => {
    setLoadingSalas(true);
    try {
      const response = await apiPrivateAntesala.get('/salas', {
        params,
        signal,
      });
      if (response.status == 201 || response.status == 200) {
        setSalas(response.data.data);
      }
    } catch (error) {
      if (error.name === "AbortError") {
        //console.log("Request aborted");
      } else {
        //console.error("Error fetching data:", error);
      }
    } finally {
      setLoadingSalas(false);
    }
  }

  // Cargar mapas disponibles para una sala
  const cargarMapasDeSala = async (salaId) => {
    if (!salaId) return;

    setLoadingMapas(true);
    try {
      const response = await RestPrivateAntesala({
        url: `/site-maps?sala_id=${salaId}`,
        method: "get",
        setLoading: () => {}
      });

      if (response.status === 200 && response.data.data) {
        const mapas = Array.isArray(response.data.data) ? response.data.data : [];
        setMapasDisponibles(mapas);

        if (mapas.length > 0) {
          setMostrarMapas(true);
        } else {
          setMostrarMapas(false);
          setMapaSeleccionado(null);
        }
      }
    } catch (error) {
      console.error("Error al cargar mapas:", error);
      setMapasDisponibles([]);
      setMostrarMapas(false);
    } finally {
      setLoadingMapas(false);
    }
  };

  // Cargar sectores del mapa como entradas
  const cargarSectoresComoEntradas = (mapa) => {
    let parsedSiteMap = null;

    try {
      parsedSiteMap = typeof mapa.site_map === 'string'
        ? JSON.parse(mapa.site_map)
        : mapa.site_map;

      if (!parsedSiteMap || !parsedSiteMap.sectores || parsedSiteMap.sectores.length === 0) {
        Alerts({
          msg: "Info",
          title: "Este mapa no tiene sectores configurados",
          code: "200",
          type: "info",
        });
        return;
      }


      console.log('parsedSiteMap.sectores', parsedSiteMap.sectores)

      // Convertir sectores a entradas
      const entradasDesdeeSectores = parsedSiteMap.sectores.map((sector) => ({
        id: [null, "required"],
        evento_id: [null, "required"],
        nombre: [sector.nombre || "Sector sin nombre", "required"],
        tipo: [sector.tipo || "Sector sin nombre", "required"],
        gratis: [sector.precio > 0 ? "VENTA" : "GRATIS", ""],
        precio: [sector.precio || 0, "required"],
        habilitacion_hora: [sector.habilitacion_hora || "00:00", "required"],
        habilitacion_fecha: [sector.habilitacion_fecha || "", "required"],
        vencimiento_fecha: [sector.vencimiento_fecha || "", ""],
        stock: [sector.stock || sector.capacidad || 0, "required"],
        sector: [sector.sector ?? null, ""],
        multiplicador: [sector.multiplicador || 1, ""],
        status_id: [1, "required"],
        created_at: ["", "required"],
        update_at: ["", "required"],
      }));

      
      console.log('entradasDesdeeSectores', entradasDesdeeSectores)

      // Actualizar form con las nuevas entradas
      setForm({
        ...form,
        entradas: [entradasDesdeeSectores, 'required'],
        mapa_teatro_id: [mapa.id, ""],
        mapa_teatro_data: [parsedSiteMap, ""]
      });

      Alerts({
        msg: "Éxito",
        title: `Se cargaron ${entradasDesdeeSectores.length} entradas desde los sectores del mapa`,
        code: "200",
        type: "success",
      });

    } catch (error) {
      console.error("Error al parsear mapa:", error);
      Alerts({
        msg: "Error",
        title: "No se pudieron cargar los sectores del mapa",
        code: "500",
        type: "error",
      });
    }
  };

  const onClick = (e, value) => {
    switch (e.target.name) {
      case "nueva-sala":
        {
          setSala(!sala);
          let input = {
            id: ['', "required"],
            evento_id: [null, "required"],
            nombre: ['', "required"],
            razon_social: ['', ""],
            email: ['', "required"],
            telefono: ['', "required"],
            direccion: ['', "required"],
            localidad: ['', "required"],
            provincia: ['', "required"],
          };

          setForm({
            ...form,
            sala: [input, "required"],
          });
        }
        break;
      case "añadir-sala":
        {
          let input = {
            id: [value.id, "required"],
            evento_id: [null, "required"],
            nombre: [value.nombre, "required"],
            razon_social: [value.razon_social, ""],
            email: [value.email, "required"],
            telefono: [value.telefono, "required"],
            direccion: [value.direccion, "required"],
            localidad: [value.localidad, "required"],
            provincia: [value.provincia, "required"],
          };

          setForm({
            ...form,
            sala: [input, "required"],
          });

          setSalaSeleccionada(true);
          setSalas([]);

          // Cargar mapas disponibles de esta sala
          cargarMapasDeSala(value.id);
        }
        break;
      case "seleccionar-mapa":
        {
          const mapa = value;
          setMapaSeleccionado(mapa);
          cargarSectoresComoEntradas(mapa);
          setMostrarMapas(false);
        }
        break;
      case "sin-mapa":
        {
          setMapaSeleccionado(null);
          setMostrarMapas(false);
          // Limpiar entradas del formulario si existían desde un mapa anterior
          setForm({
            ...form,
            entradas: [[], 'required'],
            mapa_teatro_id: [null, ""],
            mapa_teatro_data: [null, ""]
          });

          Alerts({
            msg: "Info",
            title: "Continuarás sin mapa de teatro. Podrás agregar entradas manualmente.",
            code: "200",
            type: "info",
          });
        }
        break;
      case "cambiar-mapa":
        {
          setMostrarMapas(true);
        }
        break;
    }
  };

  const onChange = (e, value) => {
    switch (e.target.name) {
      case "localidad":
      case "telefono":
      case "provincia":
      case "email":
      case "direccion":
      case "nombre":
        {
          let input = form.sala[0];
          input[e.target.name][0] = e.target.value;

          setForm({
            ...form,
            sala: [input, "required"],
          });
        }
        break;
      case "search":
        {
          //form
          let input = form;
          if (controllerRef.current) controllerRef.current.abort();

          controllerRef.current = new AbortController();
          const signal = controllerRef.current.signal;

          //
          let params = {
            ['filter[nombre]']: e.target.value,
          };

          if (
            e.target.value.length > 0 &&
            e.target.value.length > input["sala-search"][0].length
          ) {
            fetchSala(params, signal)
          }

          if (e.target.value.trim() == "") {
            fetchSala(params, signal)
          }

          setForm({
            ...form,
            ["sala-search"]: [e.target.value, ""],
          });
        }
        break;
    }
  };


  return (
    <div className="container-md w-100 tw-space-y-6">
      <div className="border p-3 mb-4 tw-bg-white tw-shadow-lg tw-border-gray-200 tw-transition-all hover:tw-shadow-xl" style={{ borderRadius: "1rem" }}>
        <div className="row">
          <div className="col-md-12 mb-3 px-1">
            <h5 className="GothamBold d-flex align-items-center tw-text-2xl tw-font-bold tw-text-gray-800 tw-mb-4">
              <i className="bi bi-geo-alt me-2 text-dark tw-mr-3 tw-text-blue-600 tw-text-3xl"></i>
              Datos del sitio
              <span className="badge bg-danger ms-2 tw-ml-3 tw-px-3 tw-py-1 tw-text-xs tw-bg-red-500 tw-text-white tw-rounded-full tw-animate-pulse" style={{ fontSize: "0.7rem" }}>Obligatorio</span>
            </h5>
            <p className="text-muted small mb-3 tw-flex tw-items-center tw-text-gray-600 tw-bg-blue-50 tw-p-3 tw-rounded-lg">
              <i className="bi bi-info-circle me-1 tw-text-blue-500 tw-text-lg tw-mr-2"></i>
              Busca una sala registrada o crea una nueva para lugares no registrados
            </p>

            <hr className="tw-border-t-2 tw-border-gray-200 tw-my-4" />

            {salaSeleccionada && (
              <div className="alert alert-success d-flex align-items-center mb-3 tw-bg-green-50 tw-border-l-4 tw-border-green-500 tw-p-4 tw-rounded-r-lg tw-shadow-md" role="alert">
                <i className="bi bi-check-circle-fill me-2 tw-text-green-600 tw-text-2xl tw-mr-3"></i>
                <div className="flex-grow-1">
                  <strong className="tw-text-green-800 tw-font-bold">Sala seleccionada:</strong> <span className="tw-text-green-700">{form.sala[0]?.nombre[0]}</span>
                  {tieneSiteMap && (
                    <div className="mt-2">
                      <span className="badge bg-warning text-dark">
                        <i className="bi bi-lock-fill me-1"></i>
                        No se puede cambiar la sala porque el evento tiene un mapa de teatro asignado
                      </span>
                    </div>
                  )}
                </div>
                {!tieneSiteMap && (
                  <button
                    className="btn btn-sm btn-outline-success tw-transition-all tw-duration-200 hover:tw-scale-105 hover:tw-bg-green-500 hover:tw-text-white tw-rounded-lg"
                    onClick={() => {
                      setSalaSeleccionada(false);
                      setSala(false);
                      setForm({
                        ...form,
                        sala: [null, "required"],
                        "sala-search": ["", ""]
                      });
                    }}
                  >
                    <i className="bi bi-arrow-repeat me-1"></i>
                    Cambiar sala
                  </button>
                )}
              </div>
            )}

            {!salaSeleccionada && (
              <>
                <div className="position-relative">
                  <InputSearchMini
                    onChange={onChange}
                    label={"Buscar sala registrada"}
                    name={"search"}
                    type={"text"}
                    value={form["sala-search"][0]}
                    //Autocomplete
                    onClick={onClick}
                    nameAutocomplete="añadir-sala"
                    valueAutocomplete={salas}
                    showIndex="nombre"
                    sendIndex="id"
                    validate={validation.sala}
                    disabled={sala}
                  />
                  {loadingSalas && (
                    <div className="position-absolute top-50 end-0 translate-middle-y me-3">
                      <div className="spinner-border spinner-border-sm text-dark" role="status">
                        <span className="visually-hidden">Buscando...</span>
                      </div>
                    </div>
                  )}
                </div>

                {salas.length === 0 && form["sala-search"][0].length > 2 && !loadingSalas && !sala && (
                  <div className="text-muted small mt-2 tw-flex tw-items-center tw-bg-gray-100 tw-p-3 tw-rounded-lg tw-mt-3">
                    <i className="bi bi-search me-1 tw-text-gray-500 tw-mr-2"></i>
                    <span className="tw-text-gray-600">No se encontraron salas con ese nombre</span>
                  </div>
                )}

                <label className={`btn ${sala ? 'btn-outline-primary' : 'btn-outline-secondary'} w-100 mt-3 tw-transition-all tw-duration-200 hover:tw-scale-[1.02] tw-shadow-md hover:tw-shadow-lg tw-rounded-xl tw-py-3 ${sala ? 'tw-bg-blue-50 tw-border-blue-400 hover:tw-bg-blue-100' : 'tw-bg-gray-50 tw-border-gray-300 hover:tw-bg-gray-100'}`} style={{ cursor: "pointer" }}>
                  {sala ? (
                    <>
                      <i className="bi bi-search me-2 tw-text-lg"></i>
                      Buscar una sala registrada
                    </>
                  ) : (
                    <>
                      <i className="bi bi-plus-circle me-2 tw-text-lg"></i>
                      Crear nueva sala (para lugares no registrados)
                    </>
                  )}
                  <button
                    name="nueva-sala"
                    className="d-none"
                    onClick={(e) => onClick(e)}
                  ></button>
                </label>
              </>
            )}
          </div>
        </div>

        {form.sala[0] && !sala ? (
          <div className="row">
            <div className="col-12 mb-3">
              <div className="alert alert-info d-flex align-items-center tw-bg-blue-50 tw-border-l-4 tw-border-blue-500 tw-p-4 tw-rounded-r-lg tw-shadow-md">
                <i className="bi bi-lock-fill me-2 tw-text-blue-600 tw-text-xl tw-mr-3"></i>
                <small className="tw-text-blue-700 tw-font-medium">Los datos mostrados están registrados y no pueden ser modificados desde aquí</small>
              </div>
            </div>
            <div className="col-md-6">
              <div className="position-relative">
                <Input
                  onChange={onChange}
                  label={"Nombre de la sala"}
                  name={"nombre"}
                  type={"text"}
                  value={form.sala[0].nombre[0]}
                  svg={'<i class="bi bi-building"></i>'}
                  validate={{ msg: "", status: false }}
                  disabled={true}
                />
                <div className="position-absolute top-0 end-0 mt-2 me-2">
                  <span className="badge bg-secondary">
                    <i className="bi bi-lock-fill"></i>
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <Input
                onChange={onChange}
                label={"Dirección"}
                name={"direccion"}
                type={"text"}
                value={form.sala[0].direccion[0]}
                svg={
                  ' <svg width="10" height="10" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_3124_63597)"><path d="M8.08541 14.5625C9.96177 14.5625 11.7613 13.8711 13.0881 12.6404C14.4148 11.4097 15.1602 9.74048 15.1602 8C15.1602 6.25952 14.4148 4.59032 13.0881 3.35961C11.7613 2.1289 9.96177 1.4375 8.08541 1.4375C6.20906 1.4375 4.40956 2.1289 3.08277 3.35961C1.75599 4.59032 1.01061 6.25952 1.01061 8C1.01061 9.74048 1.75599 11.4097 3.08277 12.6404C4.40956 13.8711 6.20906 14.5625 8.08541 14.5625ZM8.08541 15.5C5.94101 15.5 3.88443 14.7098 2.36811 13.3033C0.851788 11.8968 -7.24792e-05 9.98912 -7.24792e-05 8C-7.24792e-05 6.01088 0.851788 4.10322 2.36811 2.6967C3.88443 1.29018 5.94101 0.5 8.08541 0.5C10.2298 0.5 12.2864 1.29018 13.8027 2.6967C15.319 4.10322 16.1709 6.01088 16.1709 8C16.1709 9.98912 15.319 11.8968 13.8027 13.3033C12.2864 14.7098 10.2298 15.5 8.08541 15.5V15.5Z" fill="white" /><path d="M7.14564 6.67625L9.46012 6.94531L9.54299 7.30156L9.08818 7.37938C8.79104 7.445 8.73242 7.54438 8.79711 7.81906L9.54299 11.0703C9.73906 11.9113 9.43687 12.3069 8.72636 12.3069C8.17553 12.3069 7.53577 12.0706 7.2457 11.7463L7.15676 11.3563C7.3589 11.5213 7.65402 11.5869 7.85009 11.5869C8.12803 11.5869 8.2291 11.4059 8.15734 11.0872L7.14564 6.67625ZM7.0749 4.71875C7.0749 4.96739 7.18138 5.20585 7.37092 5.38166C7.56046 5.55748 7.81753 5.65625 8.08558 5.65625C8.35363 5.65625 8.6107 5.55748 8.80025 5.38166C8.98979 5.20585 9.09627 4.96739 9.09627 4.71875C9.09627 4.47011 8.98979 4.23165 8.80025 4.05584C8.6107 3.88002 8.35363 3.78125 8.08558 3.78125C7.81753 3.78125 7.56046 3.88002 7.37092 4.05584C7.18138 4.23165 7.0749 4.47011 7.0749 4.71875Z" fill="white" /> </g><defs><clipPath id="clip0_3124_63597"> <rect width="16.171" height="15" fill="white" transform="matrix(-1 0 0 1 16.1709 0.5)" /> </clipPath> </defs></svg>'
                }
                validate={{ msg: "", status: false }}
                disabled={true}
              />
            </div>
            <div className="col-md-6">
              <Input
                onChange={onChange}
                label={"Email"}
                name={"email"}
                type={"text"}
                value={form.sala[0].email[0]}
                svg={
                  ' <svg width="10" height="10" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_3124_63597)"><path d="M8.08541 14.5625C9.96177 14.5625 11.7613 13.8711 13.0881 12.6404C14.4148 11.4097 15.1602 9.74048 15.1602 8C15.1602 6.25952 14.4148 4.59032 13.0881 3.35961C11.7613 2.1289 9.96177 1.4375 8.08541 1.4375C6.20906 1.4375 4.40956 2.1289 3.08277 3.35961C1.75599 4.59032 1.01061 6.25952 1.01061 8C1.01061 9.74048 1.75599 11.4097 3.08277 12.6404C4.40956 13.8711 6.20906 14.5625 8.08541 14.5625ZM8.08541 15.5C5.94101 15.5 3.88443 14.7098 2.36811 13.3033C0.851788 11.8968 -7.24792e-05 9.98912 -7.24792e-05 8C-7.24792e-05 6.01088 0.851788 4.10322 2.36811 2.6967C3.88443 1.29018 5.94101 0.5 8.08541 0.5C10.2298 0.5 12.2864 1.29018 13.8027 2.6967C15.319 4.10322 16.1709 6.01088 16.1709 8C16.1709 9.98912 15.319 11.8968 13.8027 13.3033C12.2864 14.7098 10.2298 15.5 8.08541 15.5V15.5Z" fill="white" /><path d="M7.14564 6.67625L9.46012 6.94531L9.54299 7.30156L9.08818 7.37938C8.79104 7.445 8.73242 7.54438 8.79711 7.81906L9.54299 11.0703C9.73906 11.9113 9.43687 12.3069 8.72636 12.3069C8.17553 12.3069 7.53577 12.0706 7.2457 11.7463L7.15676 11.3563C7.3589 11.5213 7.65402 11.5869 7.85009 11.5869C8.12803 11.5869 8.2291 11.4059 8.15734 11.0872L7.14564 6.67625ZM7.0749 4.71875C7.0749 4.96739 7.18138 5.20585 7.37092 5.38166C7.56046 5.55748 7.81753 5.65625 8.08558 5.65625C8.35363 5.65625 8.6107 5.55748 8.80025 5.38166C8.98979 5.20585 9.09627 4.96739 9.09627 4.71875C9.09627 4.47011 8.98979 4.23165 8.80025 4.05584C8.6107 3.88002 8.35363 3.78125 8.08558 3.78125C7.81753 3.78125 7.56046 3.88002 7.37092 4.05584C7.18138 4.23165 7.0749 4.47011 7.0749 4.71875Z" fill="white" /> </g><defs><clipPath id="clip0_3124_63597"> <rect width="16.171" height="15" fill="white" transform="matrix(-1 0 0 1 16.1709 0.5)" /> </clipPath> </defs></svg>'
                }
                validate={{ msg: "", status: false }}
                disabled={true}
              />
            </div>
            <div className="col-md-6">
              <Input
                onChange={onChange}
                label={"Provincia"}
                name={"provincia"}
                type={"text"}
                value={form.sala[0].provincia[0]}
                svg={
                  ' <svg width="10" height="10" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_3124_63597)"><path d="M8.08541 14.5625C9.96177 14.5625 11.7613 13.8711 13.0881 12.6404C14.4148 11.4097 15.1602 9.74048 15.1602 8C15.1602 6.25952 14.4148 4.59032 13.0881 3.35961C11.7613 2.1289 9.96177 1.4375 8.08541 1.4375C6.20906 1.4375 4.40956 2.1289 3.08277 3.35961C1.75599 4.59032 1.01061 6.25952 1.01061 8C1.01061 9.74048 1.75599 11.4097 3.08277 12.6404C4.40956 13.8711 6.20906 14.5625 8.08541 14.5625ZM8.08541 15.5C5.94101 15.5 3.88443 14.7098 2.36811 13.3033C0.851788 11.8968 -7.24792e-05 9.98912 -7.24792e-05 8C-7.24792e-05 6.01088 0.851788 4.10322 2.36811 2.6967C3.88443 1.29018 5.94101 0.5 8.08541 0.5C10.2298 0.5 12.2864 1.29018 13.8027 2.6967C15.319 4.10322 16.1709 6.01088 16.1709 8C16.1709 9.98912 15.319 11.8968 13.8027 13.3033C12.2864 14.7098 10.2298 15.5 8.08541 15.5V15.5Z" fill="white" /><path d="M7.14564 6.67625L9.46012 6.94531L9.54299 7.30156L9.08818 7.37938C8.79104 7.445 8.73242 7.54438 8.79711 7.81906L9.54299 11.0703C9.73906 11.9113 9.43687 12.3069 8.72636 12.3069C8.17553 12.3069 7.53577 12.0706 7.2457 11.7463L7.15676 11.3563C7.3589 11.5213 7.65402 11.5869 7.85009 11.5869C8.12803 11.5869 8.2291 11.4059 8.15734 11.0872L7.14564 6.67625ZM7.0749 4.71875C7.0749 4.96739 7.18138 5.20585 7.37092 5.38166C7.56046 5.55748 7.81753 5.65625 8.08558 5.65625C8.35363 5.65625 8.6107 5.55748 8.80025 5.38166C8.98979 5.20585 9.09627 4.96739 9.09627 4.71875C9.09627 4.47011 8.98979 4.23165 8.80025 4.05584C8.6107 3.88002 8.35363 3.78125 8.08558 3.78125C7.81753 3.78125 7.56046 3.88002 7.37092 4.05584C7.18138 4.23165 7.0749 4.47011 7.0749 4.71875Z" fill="white" /> </g><defs><clipPath id="clip0_3124_63597"> <rect width="16.171" height="15" fill="white" transform="matrix(-1 0 0 1 16.1709 0.5)" /> </clipPath> </defs></svg>'
                }
                validate={{ msg: "", status: false }}
                disabled={true}
              />
            </div>
            <div className="col-md-6">
              <Input
                onChange={onChange}
                label={"Telefono"}
                name={"telefono"}
                type={"text"}
                value={form.sala[0].telefono[0]}
                svg={
                  ' <svg width="10" height="10" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_3124_63597)"><path d="M8.08541 14.5625C9.96177 14.5625 11.7613 13.8711 13.0881 12.6404C14.4148 11.4097 15.1602 9.74048 15.1602 8C15.1602 6.25952 14.4148 4.59032 13.0881 3.35961C11.7613 2.1289 9.96177 1.4375 8.08541 1.4375C6.20906 1.4375 4.40956 2.1289 3.08277 3.35961C1.75599 4.59032 1.01061 6.25952 1.01061 8C1.01061 9.74048 1.75599 11.4097 3.08277 12.6404C4.40956 13.8711 6.20906 14.5625 8.08541 14.5625ZM8.08541 15.5C5.94101 15.5 3.88443 14.7098 2.36811 13.3033C0.851788 11.8968 -7.24792e-05 9.98912 -7.24792e-05 8C-7.24792e-05 6.01088 0.851788 4.10322 2.36811 2.6967C3.88443 1.29018 5.94101 0.5 8.08541 0.5C10.2298 0.5 12.2864 1.29018 13.8027 2.6967C15.319 4.10322 16.1709 6.01088 16.1709 8C16.1709 9.98912 15.319 11.8968 13.8027 13.3033C12.2864 14.7098 10.2298 15.5 8.08541 15.5V15.5Z" fill="white" /><path d="M7.14564 6.67625L9.46012 6.94531L9.54299 7.30156L9.08818 7.37938C8.79104 7.445 8.73242 7.54438 8.79711 7.81906L9.54299 11.0703C9.73906 11.9113 9.43687 12.3069 8.72636 12.3069C8.17553 12.3069 7.53577 12.0706 7.2457 11.7463L7.15676 11.3563C7.3589 11.5213 7.65402 11.5869 7.85009 11.5869C8.12803 11.5869 8.2291 11.4059 8.15734 11.0872L7.14564 6.67625ZM7.0749 4.71875C7.0749 4.96739 7.18138 5.20585 7.37092 5.38166C7.56046 5.55748 7.81753 5.65625 8.08558 5.65625C8.35363 5.65625 8.6107 5.55748 8.80025 5.38166C8.98979 5.20585 9.09627 4.96739 9.09627 4.71875C9.09627 4.47011 8.98979 4.23165 8.80025 4.05584C8.6107 3.88002 8.35363 3.78125 8.08558 3.78125C7.81753 3.78125 7.56046 3.88002 7.37092 4.05584C7.18138 4.23165 7.0749 4.47011 7.0749 4.71875Z" fill="white" /> </g><defs><clipPath id="clip0_3124_63597"> <rect width="16.171" height="15" fill="white" transform="matrix(-1 0 0 1 16.1709 0.5)" /> </clipPath> </defs></svg>'
                }
                validate={{ msg: "", status: false }}
                disabled={true}
              />
            </div>
            <div className="col-md-6">
              <Input
                onChange={onChange}
                label={"Localidad"}
                name={"localidad"}
                type={"text"}
                value={form.sala[0].localidad[0]}
                svg={
                  ' <svg width="10" height="10" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_3124_63597)"><path d="M8.08541 14.5625C9.96177 14.5625 11.7613 13.8711 13.0881 12.6404C14.4148 11.4097 15.1602 9.74048 15.1602 8C15.1602 6.25952 14.4148 4.59032 13.0881 3.35961C11.7613 2.1289 9.96177 1.4375 8.08541 1.4375C6.20906 1.4375 4.40956 2.1289 3.08277 3.35961C1.75599 4.59032 1.01061 6.25952 1.01061 8C1.01061 9.74048 1.75599 11.4097 3.08277 12.6404C4.40956 13.8711 6.20906 14.5625 8.08541 14.5625ZM8.08541 15.5C5.94101 15.5 3.88443 14.7098 2.36811 13.3033C0.851788 11.8968 -7.24792e-05 9.98912 -7.24792e-05 8C-7.24792e-05 6.01088 0.851788 4.10322 2.36811 2.6967C3.88443 1.29018 5.94101 0.5 8.08541 0.5C10.2298 0.5 12.2864 1.29018 13.8027 2.6967C15.319 4.10322 16.1709 6.01088 16.1709 8C16.1709 9.98912 15.319 11.8968 13.8027 13.3033C12.2864 14.7098 10.2298 15.5 8.08541 15.5V15.5Z" fill="white" /><path d="M7.14564 6.67625L9.46012 6.94531L9.54299 7.30156L9.08818 7.37938C8.79104 7.445 8.73242 7.54438 8.79711 7.81906L9.54299 11.0703C9.73906 11.9113 9.43687 12.3069 8.72636 12.3069C8.17553 12.3069 7.53577 12.0706 7.2457 11.7463L7.15676 11.3563C7.3589 11.5213 7.65402 11.5869 7.85009 11.5869C8.12803 11.5869 8.2291 11.4059 8.15734 11.0872L7.14564 6.67625ZM7.0749 4.71875C7.0749 4.96739 7.18138 5.20585 7.37092 5.38166C7.56046 5.55748 7.81753 5.65625 8.08558 5.65625C8.35363 5.65625 8.6107 5.55748 8.80025 5.38166C8.98979 5.20585 9.09627 4.96739 9.09627 4.71875C9.09627 4.47011 8.98979 4.23165 8.80025 4.05584C8.6107 3.88002 8.35363 3.78125 8.08558 3.78125C7.81753 3.78125 7.56046 3.88002 7.37092 4.05584C7.18138 4.23165 7.0749 4.47011 7.0749 4.71875Z" fill="white" /> </g><defs><clipPath id="clip0_3124_63597"> <rect width="16.171" height="15" fill="white" transform="matrix(-1 0 0 1 16.1709 0.5)" /> </clipPath> </defs></svg>'
                }
                validate={{ msg: "", status: false }}
                disabled={true}
              />
            </div>
            <div className="col-md-12 mt-3">
              <h6 className="d-flex align-items-center mb-3 tw-text-lg tw-font-bold tw-text-gray-700 tw-mb-4">
                <i className="bi bi-map me-2 text-dark tw-text-blue-500 tw-text-2xl tw-mr-3"></i>
                Ubicación en el mapa
              </h6>
              <div className="border rounded overflow-hidden tw-border-2 tw-border-gray-300 tw-rounded-xl tw-shadow-lg tw-overflow-hidden" style={{ height: "450px" }}>
                <iframe
                  src={
                    "https://maps.google.com/?q=" +
                    encodeURI(
                      form.sala[0].direccion[0] +
                      ", " +
                      form.sala[0].localidad[0] +
                      ", " +
                      form.sala[0].provincia[0]
                    ) +
                    "&z=15&t=m&output=embed"
                  }
                  width="100%"
                  height="100%"
                  style={{ border: "0" }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>

            {/* Sección de Mapas de Teatro */}
            <div className="col-md-12 mt-4">
              <div className="border-top pt-4">
                <h6 className="d-flex align-items-center mb-3 tw-text-lg tw-font-bold tw-text-gray-700">
                  <i className="bi bi-diagram-3 me-2 text-dark tw-text-purple-500 tw-text-2xl tw-mr-3"></i>
                  Mapa de Asientos
                  {loadingMapas && (
                    <div className="spinner-border spinner-border-sm ms-2" role="status">
                      <span className="visually-hidden">Cargando...</span>
                    </div>
                  )}
                </h6>

                {/* Advertencia: No se puede agregar mapa en edición */}
                {!puedeAgregarSiteMap && !tieneSiteMap && (
                  <div className="alert alert-warning">
                    <i className="bi bi-exclamation-triangle-fill me-2"></i>
                    <strong>No se puede agregar mapa de teatro a este evento.</strong>
                    <p className="mb-0 mt-2 small">
                      Los mapas de teatro solo se pueden asignar durante la creación del evento.
                      Si este evento fue creado sin mapa, deberás agregar las entradas manualmente.
                    </p>
                  </div>
                )}

                {/* Mapas disponibles */}
                {puedeAgregarSiteMap && mostrarMapas && mapasDisponibles.length > 0 && (
                  <div className="alert alert-info mb-3">
                    <i className="bi bi-info-circle me-2"></i>
                    <strong>Esta sala tiene {mapasDisponibles.length} mapa(s) de asientos disponible(s).</strong>
                    <p className="mb-0 mt-2 small">
                      Selecciona un mapa para cargar automáticamente los sectores como entradas del evento, o continúa sin mapa.
                    </p>
                  </div>
                )}

                {/* Cards de mapas */}
                {puedeAgregarSiteMap && mostrarMapas && (
                  <div className="row">
                    {/* Opción: Sin mapa */}
                    <div className="col-md-4 mb-3">
                      <div
                        className="card h-100 border-secondary"
                        style={{ cursor: 'pointer', transition: 'all 0.3s' }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                        onClick={(e) => onClick({ target: { name: "sin-mapa" } })}
                      >
                        <div className="card-body d-flex flex-column align-items-center justify-content-center text-center p-4">
                          <div className="mb-3" style={{ fontSize: '48px', color: '#6c757d' }}>
                            ⊘
                          </div>
                          <h6 className="card-title text-secondary mb-2">Sin Mapa</h6>
                          <p className="card-text text-muted small">
                            Continuar sin mapa de asientos
                          </p>
                        </div>
                        <div className="card-footer bg-secondary text-white text-center">
                          <small><strong>Entradas manuales</strong></small>
                        </div>
                      </div>
                    </div>

                    {/* Mapas disponibles */}
                    {mapasDisponibles.map((mapa) => {
                      let parsedSiteMap = null;
                      let totalAsientos = 0;
                      let totalSectores = 0;
                      let nombreMapa = mapa.nombre || null;

                      try {
                        parsedSiteMap = typeof mapa.site_map === 'string'
                          ? JSON.parse(mapa.site_map)
                          : mapa.site_map;

                        totalAsientos = parsedSiteMap?.asientos?.length || 0;
                        totalSectores = parsedSiteMap?.sectores?.length || 0;

                        if (!nombreMapa && parsedSiteMap?.nombre) {
                          nombreMapa = parsedSiteMap.nombre;
                        }
                      } catch (e) {
                        console.error("Error parseando mapa:", e);
                      }

                      return (
                        <div key={mapa.id} className="col-md-4 mb-3">
                          <div
                            className="card h-100 border-success"
                            style={{ cursor: 'pointer', transition: 'all 0.3s' }}
                            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                            onClick={(e) => onClick({ target: { name: "seleccionar-mapa" } }, mapa)}
                          >
                            <div className="card-header bg-success text-white">
                              <h6 className="mb-0">
                                🗺️ {nombreMapa || `Mapa #${mapa.id}`}
                              </h6>
                            </div>
                            <div className="card-body">
                              <div className="mb-2">
                                <strong>ID:</strong>
                                <span className="badge bg-secondary ms-2">#{mapa.id}</span>
                              </div>
                              <div className="mb-2">
                                <strong>📍 Asientos:</strong>
                                <span className="badge bg-primary ms-2">{totalAsientos}</span>
                              </div>
                              <div className="mb-2">
                                <strong>🎫 Sectores:</strong>
                                <span className="badge bg-info ms-2">{totalSectores}</span>
                              </div>

                              {/* Preview de sectores */}
                              {totalSectores > 0 && parsedSiteMap?.sectores && (
                                <div className="mt-3">
                                  <small className="text-muted d-block mb-2">
                                    <strong>Sectores:</strong>
                                  </small>
                                  <div className="d-flex flex-wrap gap-1" style={{ gap: '4px' }}>
                                    {parsedSiteMap.sectores.slice(0, 3).map((sector, idx) => (
                                      <span
                                        key={idx}
                                        className="badge"
                                        style={{
                                          backgroundColor: sector.color || '#28a745',
                                          color: '#fff',
                                          fontSize: '10px'
                                        }}
                                      >
                                        {sector.nombre}
                                      </span>
                                    ))}
                                    {parsedSiteMap.sectores.length > 3 && (
                                      <span className="badge bg-secondary" style={{ fontSize: '10px' }}>
                                        +{parsedSiteMap.sectores.length - 3}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="card-footer bg-light text-center">
                              <small><strong>Click para usar este mapa</strong></small>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}

                {/* Mapa seleccionado */}
                {!mostrarMapas && mapaSeleccionado && (
                  <div className="alert alert-success d-flex align-items-center">
                    <i className="bi bi-check-circle-fill me-2 tw-text-green-600 tw-text-2xl"></i>
                    <div className="flex-grow-1">
                      <strong>Mapa seleccionado:</strong> {mapaSeleccionado.nombre || `Mapa #${mapaSeleccionado.id}`}
                      <br />
                      <small className="text-muted">
                        Los sectores de este mapa se han cargado como entradas del evento
                      </small>
                    </div>
                    <button
                      className="btn btn-sm btn-outline-success"
                      onClick={(e) => onClick({ target: { name: "cambiar-mapa" } })}
                    >
                      <i className="bi bi-arrow-repeat me-1"></i>
                      Cambiar mapa
                    </button>
                  </div>
                )}

                {/* Sin mapas disponibles */}
                {!loadingMapas && !mostrarMapas && mapasDisponibles.length === 0 && !mapaSeleccionado && (
                  <div className="alert alert-warning">
                    <i className="bi bi-exclamation-triangle me-2"></i>
                    <strong>Esta sala no tiene mapas de asientos configurados.</strong>
                    <p className="mb-0 mt-2 small">
                      Podrás agregar entradas manualmente en la siguiente sección.
                    </p>
                  </div>
                )}

                {/* Sin mapa seleccionado pero con mapas disponibles */}
                {!loadingMapas && !mostrarMapas && mapasDisponibles.length > 0 && !mapaSeleccionado && (
                  <div className="alert alert-info">
                    <i className="bi bi-info-circle me-2"></i>
                    <strong>Continuaste sin seleccionar un mapa.</strong>
                    <p className="mb-0 mt-2 small">
                      Podrás agregar entradas manualmente, o{" "}
                      <button
                        className="btn btn-link btn-sm p-0 align-baseline"
                        onClick={(e) => onClick({ target: { name: "cambiar-mapa" } })}
                      >
                        seleccionar un mapa aquí
                      </button>
                      .
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        {sala ? (
          <div className="row">
            <div className="col-12 mb-3">
              <div className="alert alert-warning d-flex align-items-center tw-bg-yellow-50 tw-border-l-4 tw-border-yellow-500 tw-p-4 tw-rounded-r-lg tw-shadow-md">
                <i className="bi bi-exclamation-triangle-fill me-2 tw-text-yellow-600 tw-text-2xl tw-mr-3"></i>
                <div>
                  <strong className="tw-text-yellow-800 tw-font-bold">Creando nueva sala</strong>
                  <br />
                  <small className="tw-text-yellow-700">Complete todos los datos de la sala. Esta información se guardará en el sistema.</small>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <Input
                onChange={onChange}
                label={"Nombre de la sala"}
                name={"nombre"}
                type={"text"}
                value={form.sala[0].nombre[0]}
                svg={'<i class="bi bi-building"></i>'}
                validate={{ msg: "", status: false }}
                disabled={false}
              />
            </div>
            <div className="col-md-6">
              <Input
                onChange={onChange}
                label={"Dirección completa"}
                name={"direccion"}
                type={"text"}
                value={form.sala[0].direccion[0]}
                svg={'<i class="bi bi-signpost"></i>'}
                validate={{ msg: "", status: false }}
                disabled={false}
              />
            </div>
            <div className="col-md-6">
              <Input
                onChange={onChange}
                label={"Email de contacto"}
                name={"email"}
                type={"email"}
                value={form.sala[0].email[0]}
                svg={'<i class="bi bi-envelope"></i>'}
                validate={{ msg: "", status: false }}
                disabled={false}
              />
            </div>
            <div className="col-md-4">
              <Input
                onChange={onChange}
                label={"Provincia"}
                name={"provincia"}
                type={"text"}
                value={form.sala[0].provincia[0]}
                svg={'<i class="bi bi-map"></i>'}
                validate={{ msg: "", status: false }}
                disabled={false}
              />
            </div>
            <div className="col-md-4">
              <Input
                onChange={onChange}
                label={"Localidad"}
                name={"localidad"}
                type={"text"}
                value={form.sala[0].localidad[0]}
                svg={'<i class="bi bi-pin-map"></i>'}
                validate={{ msg: "", status: false }}
                disabled={false}
              />
            </div>
            <div className="col-md-4">
              <Input
                onChange={onChange}
                label={"Teléfono"}
                name={"telefono"}
                type={"tel"}
                value={form.sala[0].telefono[0]}
                svg={'<i class="bi bi-telephone"></i>'}
                validate={{ msg: "", status: false }}
                disabled={false}
              />
            </div>
            <div className="col-md-12 mt-3">
              <h6 className="d-flex align-items-center mb-3 tw-text-lg tw-font-bold tw-text-gray-700 tw-mb-4">
                <i className="bi bi-map me-2 text-dark tw-text-blue-500 tw-text-2xl tw-mr-3"></i>
                Vista previa de ubicación
              </h6>
              <div className="alert alert-info d-flex align-items-start tw-bg-blue-50 tw-border-l-4 tw-border-blue-500 tw-p-4 tw-rounded-r-lg tw-shadow-md tw-mb-4">
                <i className="bi bi-info-circle me-2 mt-1 tw-text-blue-600 tw-text-xl tw-mr-2"></i>
                <small className="tw-text-blue-700">
                  El mapa se actualizará automáticamente cuando completes la dirección, localidad y provincia.
                  Verifica que la ubicación sea correcta.
                </small>
              </div>
              <div className="border rounded overflow-hidden tw-border-2 tw-border-gray-300 tw-rounded-xl tw-shadow-lg tw-overflow-hidden" style={{ height: "450px" }}>
                <iframe
                  src={
                    "https://maps.google.com/?q=" +
                    encodeURI(
                      form.sala[0].direccion[0] +
                      ", " +
                      form.sala[0].localidad[0] +
                      ", " +
                      form.sala[0].provincia[0]
                    ) +
                    "&z=15&t=m&output=embed"
                  }
                  width="100%"
                  height="100%"
                  style={{ border: "0" }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default Donde;
